module.exports = __webpack_public_path__ + "img/128.70a7c3ce.jpg";